import { Injectable, inject } from '@angular/core';
import { DateAdapter } from '@angular/material/core';
import { DateRange, MatDateRangeSelectionStrategy } from '@angular/material/datepicker';

@Injectable()
export class WeekRangeSelectionStrategy<D> implements MatDateRangeSelectionStrategy<D> {
  private _dateAdapter = inject<DateAdapter<D>>(DateAdapter<D>);

  selectionFinished(date: D | null): DateRange<D> {
    return this._createWeekRange(date);
  }

  createPreview(activeDate: D | null): DateRange<D> {
    return this._createWeekRange(activeDate);
  }

  private _createWeekRange(date: D | null): DateRange<D> {
    if (!date) return new DateRange<D>(null, null);

    // getDayOfWeek returns Luxon's ISO weekday: Mon=1, Tue=2, ..., Sat=6, Sun=7
    const dayOfWeek = this._dateAdapter.getDayOfWeek(date);
    const diffToSunday = -(dayOfWeek % 7);
    const start = this._dateAdapter.addCalendarDays(date, diffToSunday);
    const end = this._dateAdapter.addCalendarDays(start, 6);

    return new DateRange<D>(start, end);
  }
}
